import {useEffect, useState} from "react";
import ApiService from "../../core/service/ApiService";
import {Select} from "antd";
import {useUser} from "../../core/context/UserContext";
import { matchesSearch } from "../../core/utils/text-search";

export default function AppointmentTypeSelect({onTypes, ...props}) {
    const {firmSettings} = useUser();
    const [types, setTypes] = useState([])

    const get = async () => {
        const res = await ApiService.Appointment.GetAppointmentTypes()
        if(res.success) {
            setTypes(res.data)
            onTypes && onTypes(res.data)
        }
    }

    useEffect(() => {
        get()
    }, []);

    return (
        <Select
            size={'small'}
            showSearch={true}
            filterOption={(input, option) => {
                return matchesSearch(option?.children, input)
            }}
            {...props}
        >
            {
                types.map(t => (
                    <Select.Option value={t.id} key={t.id}>
                        {t.name}
                    </Select.Option>
                ))
            }
        </Select>
    )
}